<template>
    <div  v-if="(item['thumbnails'] && onlyImage) || !onlyImage" class="card"  >
        <img v-if="item['thumbnails']" :src="item['thumbnails'][0]" class="card-img-top" />
        <img v-else src="../assets/reiwa-square.png" class="card-img-top"/>
        
        <div :class="'card-img-overlay py-0 px-0' + (!onlyImage ? ' news-card-overlay': '')" style="overflow:hidden">
            <div v-if="!onlyImage" class="card-header text-dark bg-transparent p-0">
                <small >{{item.pubDate | toLocaleTime}}</small>
            </div>
            <div class="card-body align-left p-2" >       
                <a :href="item.link" target="_blank">
                    <h6 v-if="!onlyImage" class="card-title text-truncate"><small>{{item.title}}</small></h6>
                </a>                                    
                <div v-if="!onlyImage" class="card-text" ><small><small class="card-link text-muted description " style="overflow:hidden">{{toText(item.description)}}</small></small></div>                
            </div>
            <div style="position:absolute; right: 1em; bottom: 1em">
                <b-button v-b-modal.display_article v-on:click="$emit('update-current-item', item); log('item-clicked', $parent, item);" :class="'btn-light ' + (onlyImage ? 'btn-transparent': '')" size="sm">詳細</b-button>
            </div>   
        </div>
    </div>
</template>

<script>
export default {
    props: ['item', 'onlyImage'],
    data() {
        return {
        }
    },
    methods:{
        stripHtml(html) {
            var tmp = document.createElement("div");
            tmp.innerHTML = html;
            return tmp.textContent || tmp.innerText || "";
        },
        toText(description) {
            let text = this.stripHtml(description);
            return text;
        },
    },
    filters : {
        toArticleStyle(item) {
            // console.log('toArticleStyle');
            if (item == undefined) return '';
            // console.log(item.title);
            result = `${item.title}: <a href="${item.link}">${item.description}</a>`;
            // console.log('toArticleStyle', result);
            return result;
        },
        toLocaleTime(timeString) {
            timeString = timeString.replace(' +0000', '+00:00').replace(' +0900', '+09:00').replace(' ','T');
            let pubDate = new Date(timeString).toLocaleString('ja-jp');
            return pubDate;
        }
  },
}
</script>

<style>
#card .card-footer {
    position: fixed;
    bottom: 0;
}


.news-card-overlay {
  background-color: rgba(255, 255, 255, 0.85);
}

.news-card-overlay:hover {
  background-color: rgba(255, 255, 255, 0.99);
  transition: background-color 0.25s;
}

.btn-transparent {
    opacity: 0.5;
}


</style>
